import clsx from "clsx";

/**
 * 価格（fromPrice）読み込み中のプレースホルダー。
 * 二段フェッチの構造フェーズ（availabilities 未取得）で価格の位置に表示する。
 * デフォルトの高さ（28px）は RoomTypeRow / SingleSelectionArchitecture /
 * ArchitectureTypeGroup が実表示する価格行の leading-[28px] に揃えている。
 * 揃えないと選択直後のスクロールアニメーション中に価格が届いて一覧の高さが変わり、
 * scrollIntoView の着地位置がずれる（呼び出し側で高さの異なる箇所は className で上書きする）。
 */
export function PriceSkeleton({ className }: { className?: string }) {
  return (
    <span
      className={clsx(
        "bg-dx-surface-subtle inline-block h-[28px] w-[80px] animate-pulse rounded-sm",
        className,
      )}
      aria-hidden
    />
  );
}
